import {Button, UnstableCard as Paper} from '@yandex-delivery/blocks'
import {spacing} from '@yandex-delivery/blocks/theme/theme'
import clsx from 'clsx'
import type {ReactElement} from 'react'

import {FloatingBox, StickyTo} from '../../components/FloatingBox'
import {renderWidget} from '..'
import type {ActionButtonWidgetProps as Props} from '../types'
import * as classes from './ActionButton.classes'
import {useActionButtonProps} from './hooks'

export function ActionButtonWidget(props: Props): ReactElement {
  const {style, size, handlePress, actionElement, slots} =
    useActionButtonProps(props)

  return (
    <FloatingBox
      className={classes.floatingWrapper}
      height={spacing(9)}
      stickyTo={StickyTo.BLOCK_END}
    >
      <Paper className={classes.actionButtonWrapper} padding="S" radius="L">
        <Button
          disabled={!style.enabled}
          onPress={handlePress}
          size={size}
          variant={style.style === 'main' ? 'action' : 'default'}
          fullWidth
          px="s"
          className={clsx(classes.slotsGrid, {[classes.disabledOpacityOverride]: !style.enabled})}
        >
          {slots.map((slot, i) => (
            <span
              key={i}
              className={
                slot.align === 'leading'
                  ? classes.slotLeading
                  : slot.align === 'trailing'
                    ? classes.slotTrailing
                    : classes.slotCenter
              }
            >
              {slot.title.items.map(renderWidget)}
              {slot.subtitle && slot.subtitle.items.map(renderWidget)}
            </span>
          ))}

          {actionElement}
        </Button>
      </Paper>
    </FloatingBox>
  )
}
